import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { FC } from 'react';
import MarkdownPresenter from './MarkdownPresenter';
import './GptMessageBar.scss';

interface GptMessageBarProps {
    title: string;
    text: string;
}
  
const GptMessageBar: FC<GptMessageBarProps> = ({ title, text }) => {
    return (
        <MessageBar key={'info'} intent='info' className="gpt-message-bar">
            <MessageBarBody className="gpt-message-bar__body">
                <MessageBarTitle className="gpt-message-bar__title">{title}</MessageBarTitle>
                <div className="gpt-message-bar__markdown">
                    <MarkdownPresenter text={text} />
                </div>
            </MessageBarBody>
        </MessageBar>
    );
};

export default GptMessageBar;

